module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.state.error) ? _c('page-error') : _c('breadcrumbs-layout', {
    attrs: {
      "breadcrumbs": _vm.crumbs
    }
  }, [_c('VerifyEmailText', {
    attrs: {
      "link-text": "Перейти в ЦОПП",
      "messageData": _vm.messageData,
      "linkPath": {
        path: '/'
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2abbc36","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/verify/email/Email.vue
// module id = 806e2699afe6b31daca5
// module chunks = 28